import type { ReactNode } from "react";
import { ChangeText } from "~/components/layout/text/ChangeText";

export const Em = ({ children }: { children: ReactNode }) => {
    return <ChangeText decoration="italic">{children}</ChangeText>;
};
